import { useState } from 'react';

function useTab(): [number, (value: number) => void] {
  const [currentIndexTab, setCurrentIndexTab] = useState(0);

  return [currentIndexTab, setCurrentIndexTab];
}

export default useTab;
